var render = function render(){
  var _this$selectedCampaig, _vm$profile, _vm$profile$company;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "products"
  }, [_c('h4', {
    staticClass: "main-header"
  }, [_vm._v(_vm._s(_vm.$t('products')))]), _vm.companySetupError ? _c('div', {
    staticClass: "empty-state-ctn mt-5"
  }, [_c('div', {
    staticClass: "py-4 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.$t('company_setup_error')) + " " + _vm._s(_vm.$t('contact_support_for_help')) + " ")])]) : _c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    staticClass: "product-list flex-grow-1",
    class: {
      'pl-2': _vm.campaigns.length == 1
    }
  }, [_c('div', {
    staticClass: "product-actions-ctn d-flex flex-wrap mb-5 pt-2 align-center"
  }, [_c('div', {
    staticClass: "mr-3 order-first"
  }, [_c('v-btn', {
    staticClass: "md-raised primary",
    attrs: {
      "disabled": _vm.usedCodesCount >= _vm.totalCodesCount
    },
    on: {
      "click": _vm.openCreateProductModal
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-plus")]), _vm._v(_vm._s(_vm.$t('new_product')) + " ")], 1)], 1), _c('div', {
    staticClass: "mr-3",
    class: _vm.$vuetify.breakpoint.smAndDown ? 'ml-auto order-2' : 'ml-3 order-3'
  }, [_c('codes-quota')], 1), _c('div', {
    staticClass: "search-wrapper",
    class: _vm.$vuetify.breakpoint.smAndDown ? 'order-3 w-100 mt-3' : 'flex-grow-1 order-2'
  }, [_vm.totalCodesCount > 0 ? _c('v-form', {
    staticClass: "w-100",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('search_product_placeholder'),
      "solo": "",
      "hide-details": "",
      "dense": "",
      "append-icon": "mdi-magnify"
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1) : _vm._e()], 1)]), _vm.products.length || _vm.search ? _c('div', {
    staticClass: "product-table"
  }, [_c('v-row', {
    staticClass: "product-table-header font-light pa-0 ma-0"
  }, [_c('v-col', [_vm._v(_vm._s(_vm.$t('products')))]), !_vm.$vuetify.breakpoint.smAndDown ? _c('v-col', {
    staticClass: "d-flex justify-start",
    attrs: {
      "cols": 5
    }
  }, [_vm._v(_vm._s(_vm.$t('url_and_gs1_dl')))]) : _vm._e(), _c('v-col', {
    staticClass: "d-flex justify-start",
    attrs: {
      "cols": _vm.$vuetify.breakpoint.smAndDown ? 5 : 2
    }
  }, [_vm._v(_vm._s(_vm.$t('qr_code')))]), _c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": !_vm.$vuetify.breakpoint.smAndDown ? 1 : 2
    }
  }, [_vm._v(_vm._s(_vm.$t('actions')))])], 1), _vm.loadingProducts ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._l(_vm.products, function (product) {
    var _product$code;
    return _c('v-row', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.loadingProducts,
        expression: "!loadingProducts"
      }],
      key: product.id,
      staticClass: "pa-0 ma-0 product-table-item"
    }, [_c('v-col', {
      staticClass: "product-cell",
      attrs: {
        "align-self": "center"
      },
      on: {
        "click": function ($event) {
          return _vm.goToProductDetails(product, 'info');
        }
      }
    }, [_c('v-row', {
      staticClass: "pa-0 ma-0",
      attrs: {
        "align": "center"
      }
    }, [product.image ? _c('v-col', {
      staticClass: "product-image-ctn pa-0"
    }, [_c('img', {
      staticClass: "product-image",
      attrs: {
        "src": product.image
      }
    })]) : _vm._e(), _c('v-col', {
      staticClass: "product-name-ctn"
    }, [_c('span', {
      staticClass: "font-medium mr-2"
    }, [_vm._v(_vm._s(product.name))]), !_vm.$vuetify.breakpoint.smAndDown ? _c('span', {
      staticClass: "product-sku"
    }, [_vm._v(_vm._s(product.sku))]) : _vm._e()])], 1)], 1), !_vm.$vuetify.breakpoint.smAndDown ? _c('v-col', {
      staticClass: "text-break",
      attrs: {
        "cols": 5,
        "align-self": "center"
      },
      on: {
        "click": function ($event) {
          return _vm.goToProductDetails(product, 'gs1');
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.systemPrefix) + _vm._s((_product$code = product.code) === null || _product$code === void 0 ? void 0 : _product$code.message) + " ")]) : _vm._e(), _c('v-col', {
      attrs: {
        "align-self": "center",
        "cols": _vm.$vuetify.breakpoint.smAndDown ? 5 : 2
      },
      on: {
        "click": function ($event) {
          return _vm.goToProductDetails(product, 'qr');
        }
      }
    }, [_c('v-row', {
      staticClass: "pa-0 ma-0",
      attrs: {
        "align": "center"
      }
    }, [product.code ? _c('div', {
      staticClass: "qr-preview-ctn"
    }, [_c('img', {
      staticClass: "qr",
      attrs: {
        "src": _vm.previewUrl(product)
      }
    }), _vm.qrTemplates[product.id] && _vm.qrTemplates[product.id].image ? _c('img', {
      staticClass: "logo",
      style: {
        backgroundColor: _vm.qrTemplates[product.id].background
      },
      attrs: {
        "src": _vm.toDataUrl(_vm.qrTemplates[product.id].image)
      }
    }) : _vm._e()]) : _vm._e()])], 1), _c('v-col', {
      staticClass: "text-center",
      attrs: {
        "align-self": "center",
        "cols": !_vm.$vuetify.breakpoint.smAndDown ? 1 : 2
      }
    }, [_c('v-menu', {
      attrs: {
        "bottom": "",
        "left": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "icon": "",
              "color": "primary"
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)];
        }
      }], null, true)
    }, [_c('v-list', [_c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.goToProductDetails(product, 'info');
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('edit_product_information')))])], 1), _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.goToProductDetails(product, 'gs1');
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('manage_gs1_digital_link')))])], 1), _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.goToProductDetails(product, 'qr');
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('edit_qr_code_style')))])], 1), _c('v-list-item', {
      attrs: {
        "link": ""
      },
      on: {
        "click": function ($event) {
          return _vm.goToProductDetails(product, 'redirection');
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('manage_scan_destination')))])], 1)], 1)], 1)], 1)], 1);
  }), _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loadingProducts && !_vm.products.length,
      expression: "!loadingProducts && !products.length"
    }],
    staticClass: "pa-2 ma-0 product-table-item"
  }, [_vm._v(" " + _vm._s(_vm.$t('no_product_found')) + " ")])], 2) : !_vm.loadingProducts && !_vm.search ? _c('div', {
    staticClass: "empty-state-ctn"
  }, [_c('img', {
    staticClass: "main-image",
    attrs: {
      "src": require("@/assets/empty-state-products.svg"),
      "alt": ""
    }
  }), _c('div', {
    staticClass: "welcome"
  }, [_vm._v(_vm._s(_vm.$t('empty_state_welcome')))]), _c('div', {
    staticClass: "product-info"
  }, [_c('div', {
    staticClass: "create-product"
  }, [_vm._v(_vm._s(_vm.$t('empty_state_create_product')))]), _c('v-btn', {
    staticClass: "md-raised primary",
    attrs: {
      "disabled": _vm.usedCodesCount >= _vm.totalCodesCount
    },
    on: {
      "click": _vm.openCreateProductModal
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-plus")]), _vm._v(_vm._s(_vm.$t('new_product')) + " ")], 1)], 1)]) : _vm._e(), _c('div', {
    staticClass: "pagination-ctn mt-5 mb-4"
  }, [_c('v-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loadingProducts && _vm.filteredProductCount > 0,
      expression: "!loadingProducts && filteredProductCount > 0"
    }],
    attrs: {
      "color": "primary",
      "total-visible": 7,
      "length": _vm.nbPages
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)])], 1), _c('v-dialog', {
    attrs: {
      "width": "1000",
      "persistent": true
    },
    model: {
      value: _vm.productDialog,
      callback: function ($$v) {
        _vm.productDialog = $$v;
      },
      expression: "productDialog"
    }
  }, [_c('product-creation', {
    ref: "productCreation",
    attrs: {
      "campaign": (_this$selectedCampaig = this.selectedCampaign) === null || _this$selectedCampaig === void 0 ? void 0 : _this$selectedCampaig.id
    },
    on: {
      "on-product-created": _vm.onProductCreated,
      "on-close-dialog": function ($event) {
        return _vm.handleCloseDialog();
      }
    }
  })], 1), (_vm$profile = _vm.profile) !== null && _vm$profile !== void 0 && (_vm$profile$company = _vm$profile.company) !== null && _vm$profile$company !== void 0 && _vm$profile$company.id && _vm.isUpgradePlanOpen ? _c('checkout-dialog', {
    ref: "paddle-checkout-dialog",
    attrs: {
      "openModal": _vm.isUpgradePlanOpen,
      "selectedPlan": _vm.selectedPlan,
      "isYearlyPayment": _vm.billingCycle === 'year'
    },
    on: {
      "close": _vm.handleCheckoutPopupClose
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }